import styled from 'styled-components';

export const StepperWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-top: ${({ theme }) => theme.spacings.medium};
	position: relative;
	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		margin: ${({ theme }) => theme.spacings.medium};
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.small};
`;

export const Question = styled.span`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const QuestionSubtitle = styled.span`
	${({ theme }) => theme.fonts.text.text2};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Title = styled.h1`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	margin: 0;
`;

export const Subtitle = styled.span`
	${({ theme }) => theme.fonts.text.text5};
	color: ${({ theme }) => theme.colors.text.main.subtle};
`;

export const RegulatoryText = styled.span`
	${({ theme }) => theme.fonts.text.text3};
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;

export const CheckboxText = styled.span`
	${({ theme }) => theme.fonts.text.text5};
`;

export const CheckboxesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const ReadMore = styled.a`
	${({ theme }) => theme.fonts.text.text1};
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;

export const RadioButtonsContainer = styled.div<{ $vertical?: boolean }>`
	display: flex;
	flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')};
	gap: ${({ theme }) => theme.spacings.medium};
`;

export const RadioButtonWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ModalTitle = styled.span`
	${({ theme }) => theme.fonts.headings.title6};
	margin-top: ${({ theme }) => theme.spacings.large};
	margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
`;

export const ModalSubtitle = styled.span`
	${({ theme }) => theme.fonts.text.text3};
	text-align: center;
	margin-bottom: ${({ theme }) => theme.spacings.large};
`;

export const ModalDescription = styled.span`
	${({ theme }) => theme.fonts.text.text3};
	text-align: center;
	white-space: pre-line;
	margin-bottom: ${({ theme }) => theme.spacings.large};
`;

export const ModalButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xsmall};
`;
